const StringUtils = {
  // escape string for use with js regex call
  escapeRegExp: (str) => str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), // $& means the whole matched string
  capitalizeFirstLetter: (str) => str.charAt(0).toUpperCase() + str.slice(1),
};
export default StringUtils;
